import { render, staticRenderFns } from "./OverviewV1.vue?vue&type=template&id=50177f6b&scoped=true&lang=pug"
import script from "./OverviewV1.vue?vue&type=script&lang=js"
export * from "./OverviewV1.vue?vue&type=script&lang=js"
import style0 from "./OverviewV1.vue?vue&type=style&index=0&id=50177f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50177f6b",
  null
  
)

export default component.exports